/**
 * Contract status enum. Values match the API and DB (stored as int).
 * Use these IDs for comparisons and API requests; use contractStatusLabel() for display.
 */
export const ContractStatus = {
  Draft: 0,
  AwaitingCustomerSignature: 1,
  AwaitingMarinaSignature: 2,
  AwaitingInitialPayment: 3,
  Contracted: 4,
  PendingTermination: 5,
  Terminated: 6,
  Expired: 7,
} as const;

export type ContractStatusValue = (typeof ContractStatus)[keyof typeof ContractStatus];

const LABELS: Record<number, string> = {
  [ContractStatus.Draft]: 'Draft',
  [ContractStatus.AwaitingCustomerSignature]: 'Awaiting Customer Signature',
  [ContractStatus.AwaitingMarinaSignature]: 'Awaiting Marina Signature',
  [ContractStatus.AwaitingInitialPayment]: 'Awaiting Initial Payment',
  [ContractStatus.Contracted]: 'Contracted',
  [ContractStatus.PendingTermination]: 'Pending Termination',
  [ContractStatus.Terminated]: 'Terminated',
  [ContractStatus.Expired]: 'Expired',
};

/** Get display label for a contract status ID. */
export function contractStatusLabel(status: number | null | undefined): string {
  if (status == null) return '';
  return LABELS[status] ?? '';
}
